import { render, staticRenderFns } from "./forgotPasswordConfirm.vue?vue&type=template&id=5ec8bd4b&"
import script from "./forgotPasswordConfirm.vue?vue&type=script&lang=ts&"
export * from "./forgotPasswordConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports